var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"register3-plan-step"},[_c('el-row',[_c('el-col',[_c('el-steps',{attrs:{"active":_vm.step}},[_c('el-step',{attrs:{"title":"Step 1","description":"お客様情報の入力・決済"}}),_c('el-step',{attrs:{"title":"Step 2","description":"ログイン情報の発行"}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }